module.exports = __webpack_public_path__ + "img/20190619164116032.a2c3272a.png";